import { render, staticRenderFns } from "./CloseSaleMali.vue?vue&type=template&id=b5a8363a&"
import script from "./CloseSaleMali.vue?vue&type=script&lang=js&"
export * from "./CloseSaleMali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports